/* ==========================================================================
   Maison Sculptea — script principal (vanilla JS, sans dépendance externe)
   ========================================================================== */
(function () {
  "use strict";

  /* ---------- Utilities ---------------------------------------------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    return (format || "{{amount}} €").replace("{{amount}}", value);
  }
  function announce(msg) {
    var live = qs("#quick-add-live");
    if (live) { live.textContent = ""; setTimeout(function () { live.textContent = msg; }, 50); }
  }

  /* ---------- Mobile navigation ---------------------------------------- */
  function initMobileNav() {
    var toggle = qs("[data-mobile-nav-toggle]");
    var nav = qs("[data-mobile-nav]");
    var close = qs("[data-mobile-nav-close]");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () {
      nav.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
    function closeNav() {
      nav.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    if (close) close.addEventListener("click", closeNav);
    nav.addEventListener("click", function (e) {
      if (e.target === nav) closeNav();
    });
  }

  /* ---------- Cart drawer / AJAX cart ----------------------------------- */
  var Cart = {
    drawer: null,
    overlay: null,
    init: function () {
      this.drawer = qs("[data-cart-drawer]");
      this.overlay = qs("[data-cart-drawer-overlay]");
      if (!this.drawer) return;

      qsa("[data-cart-open]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          Cart.open();
        });
      });
      var closeBtn = qs("[data-cart-close]", this.drawer);
      if (closeBtn) closeBtn.addEventListener("click", function () { Cart.close(); });
      if (this.overlay) this.overlay.addEventListener("click", function () { Cart.close(); });

      this.drawer.addEventListener("click", function (e) {
        var removeBtn = e.target.closest("[data-cart-remove]");
        var minusBtn = e.target.closest("[data-cart-decrease]");
        var plusBtn = e.target.closest("[data-cart-increase]");
        if (removeBtn) {
          e.preventDefault();
          Cart.changeLine(removeBtn.dataset.cartRemove, 0);
        } else if (minusBtn) {
          e.preventDefault();
          var lineMinus = minusBtn.closest("[data-cart-line]");
          var qtyMinus = parseInt(lineMinus.querySelector("[data-cart-qty-input]").value, 10) - 1;
          Cart.changeLine(minusBtn.dataset.cartDecrease, Math.max(qtyMinus, 0));
        } else if (plusBtn) {
          e.preventDefault();
          var linePlus = plusBtn.closest("[data-cart-line]");
          var qtyPlus = parseInt(linePlus.querySelector("[data-cart-qty-input]").value, 10) + 1;
          Cart.changeLine(plusBtn.dataset.cartIncrease, qtyPlus);
        }
      });

      // Tous les formulaires d'ajout au panier de la page (fiche produit, ajout rapide)
      qsa('form[data-product-form]').forEach(function (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          Cart.submitForm(form);
        });
      });

    },
    open: function () {
      this.refresh().then(function () {
        Cart.drawer.classList.add("is-open");
        if (Cart.overlay) Cart.overlay.classList.add("is-open");
        document.body.style.overflow = "hidden";
      });
    },
    close: function () {
      this.drawer.classList.remove("is-open");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    },
    refresh: function () {
      return fetch("/cart?view=drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var newContent = doc.querySelector("[data-cart-drawer-content]");
          var target = qs("[data-cart-drawer-content]");
          if (newContent && target) target.innerHTML = newContent.innerHTML;
          Cart.updateCount();
        })
        .catch(function () {});
    },
    updateCount: function () {
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        qsa("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      });
    },
    submitForm: function (form) {
      // Fiche produit avec offre Duo/Trio : on ajoute les N vraies variantes choisies,
      // pas le formulaire simple (qui n'en enverrait qu'une).
      var packRoot = form.closest("[data-product-root]");
      var packCtx = packRoot && packRoot.__sculpteaPack;
      if (packCtx) {
        Cart.addPack(packCtx, form.querySelector('[type="submit"]'));
        return;
      }
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", { method: "POST", body: formData, headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            announce(data.description || "Erreur lors de l'ajout au panier");
          } else {
            announce("Article ajouté au panier");
            Cart.open();
          }
        })
        .catch(function () { announce("Erreur lors de l'ajout au panier"); })
        .finally(function () { if (submitBtn) submitBtn.removeAttribute("disabled"); });
    },
    /* Ajoute au panier les N vraies variantes Shopify du pack choisi (1 ligne par article). */
    addPack: function (ctx, btn) {
      var items = PackOffer.items(ctx);
      var tier = PackOffer.tier(ctx);
      if (items.length !== tier.qty) {
        announce("Merci de choisir un coloris et une taille pour chaque article de l'offre.");
        return;
      }
      if (btn) btn.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status || data.description) {
            announce(data.description || "Erreur lors de l'ajout — vérifiez la disponibilité des articles choisis.");
          } else {
            announce(tier.qty > 1 ? "Offre ajoutée au panier" : "Article ajouté au panier");
            Cart.open();
          }
        })
        .catch(function () { announce("Erreur lors de l'ajout au panier"); })
        .finally(function () {
          if (btn) btn.removeAttribute("disabled");
          PackOffer.refresh(ctx);
        });
    },
    changeLine: function (key, quantity) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function () { return Cart.refresh(); });
    }
  };

  /* ---------- Offres Duo / Trio (packs Maison Sculptea) ------------------
     Chaque article du pack résout SA PROPRE variante Shopify réelle (couleur + taille
     indépendantes), par position d'option, exactement comme le formulaire principal.
     Aucune variante inventée : un article n'est valide que si la combinaison existe
     réellement dans product.variants ET qu'elle est disponible à la vente.
     Le prix du pack affiché vient du Liquid (data-pack-total) ; la remise réelle est
     appliquée au panier par les remises automatiques Shopify (voir SUIVI_PROJET.md).
     ------------------------------------------------------------------- */
  function escapeAttr(value) {
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/["\\]/g, "\\$&");
  }

  var PackOffer = {
    init: function () {
      qsa("[data-pack-offer]").forEach(function (packEl) {
        var root = packEl.closest("[data-product-root]");
        if (!root) return;
        var script = qs("[data-product-json]", root);
        if (!script) return;
        var product;
        try { product = JSON.parse(script.textContent); } catch (e) { return; }

        var ctx = {
          root: root,
          packEl: packEl,
          product: product,
          storageKey: packEl.dataset.packStorageKey || ("sculptea-pack-" + product.id)
        };
        root.__sculpteaPack = ctx;

        qsa("[data-pack-tier]", packEl).forEach(function (radio) {
          radio.addEventListener("change", function () {
            PackOffer.applyTier(ctx);
            PackOffer.persist(ctx);
          });
        });

        qsa("[data-pack-item]", root).forEach(function (item) {
          qsa("select", item).forEach(function (sel) {
            sel.addEventListener("change", function () {
              PackOffer.resolveItem(ctx, item);
              PackOffer.refresh(ctx);
              PackOffer.persist(ctx);
            });
          });
        });

        PackOffer.restore(ctx);
        PackOffer.applyTier(ctx);
      });
    },

    /* Palier actuellement coché : quantité et prix total réel du pack (en centimes). */
    tier: function (ctx) {
      var checked = qs("[data-pack-tier]:checked", ctx.packEl);
      if (!checked) return { qty: 1, total: parseInt(ctx.packEl.dataset.packUnitPrice, 10) || 0 };
      return {
        qty: parseInt(checked.dataset.packQty, 10) || 1,
        total: parseInt(checked.dataset.packTotal, 10) || 0
      };
    },

    applyTier: function (ctx) {
      var tier = PackOffer.tier(ctx);

      qsa(".pack-tier", ctx.packEl).forEach(function (label) {
        var input = qs("[data-pack-tier]", label);
        label.classList.toggle("is-selected", !!(input && input.checked));
      });

      var firstLabel = qs("[data-pack-first-label]", ctx.root);
      if (firstLabel) firstLabel.hidden = tier.qty < 2;

      qsa("[data-pack-item]", ctx.root).forEach(function (item) {
        var index = parseInt(item.dataset.packItemIndex, 10);
        var active = index <= tier.qty;
        item.hidden = !active;
        if (active) PackOffer.resolveItem(ctx, item);
      });

      PackOffer.refresh(ctx);
    },

    /* Résout la vraie variante Shopify d'un article du pack + grise les combinaisons inexistantes. */
    resolveItem: function (ctx, item) {
      var colorSelect = qs("[data-pack-color]", item);
      var sizeSelect = qs("[data-pack-size]", item);
      var variantInput = qs("[data-pack-variant-id]", item);
      var errorEl = qs("[data-pack-item-error]", item);
      var variants = ctx.product.variants;

      function selectionFrom(overrideSelect, overrideValue) {
        var selected = [];
        [colorSelect, sizeSelect].forEach(function (sel) {
          if (!sel) return;
          var idx = parseInt(sel.dataset.packOptionIndex, 10);
          var value = sel === overrideSelect ? overrideValue : sel.value;
          selected[idx] = value || null;
        });
        return selected;
      }

      function match(selected, requireAvailable) {
        return variants.find(function (v) {
          if (requireAvailable && !v.available) return false;
          return v.options.every(function (opt, i) {
            return selected[i] == null || opt === selected[i];
          });
        });
      }

      // Grise les valeurs qui ne correspondent à aucune variante réelle disponible.
      [colorSelect, sizeSelect].forEach(function (sel) {
        if (!sel) return;
        qsa("option", sel).forEach(function (opt) {
          if (opt.value === "") return;
          opt.disabled = !match(selectionFrom(sel, opt.value), true);
        });
      });

      var complete = (!colorSelect || !!colorSelect.value) && (!sizeSelect || !!sizeSelect.value);
      var variant = complete ? match(selectionFrom(null, null), false) : null;
      var usable = !!(variant && variant.available);

      if (variantInput) variantInput.value = usable ? variant.id : "";
      if (errorEl) errorEl.hidden = !(complete && !usable);
      item.classList.toggle("has-error", complete && !usable);
    },

    /* Article 1 = la sélection du formulaire produit principal (swatches + pastilles). */
    firstVariantId: function (ctx) {
      var idInput = qs('input[name="id"]', ctx.root);
      return idInput && idInput.value ? idInput.value : null;
    },

    firstVariantAvailable: function (ctx) {
      var id = PackOffer.firstVariantId(ctx);
      if (!id) return false;
      var variant = ctx.product.variants.find(function (v) { return String(v.id) === String(id); });
      return !!(variant && variant.available);
    },

    /* Liste des articles réellement ajoutables (vraies variantes, dans l'ordre affiché). */
    items: function (ctx) {
      var tier = PackOffer.tier(ctx);
      var items = [];
      var firstId = PackOffer.firstVariantId(ctx);
      if (firstId && PackOffer.firstVariantAvailable(ctx)) items.push({ id: firstId, quantity: 1 });
      qsa("[data-pack-item]", ctx.root).forEach(function (item) {
        var index = parseInt(item.dataset.packItemIndex, 10);
        if (index > tier.qty) return;
        var input = qs("[data-pack-variant-id]", item);
        if (input && input.value) items.push({ id: input.value, quantity: 1 });
      });
      return items;
    },

    complete: function (ctx) {
      return PackOffer.items(ctx).length === PackOffer.tier(ctx).qty;
    },

    /* Bouton d'ajout : libellé avec le vrai prix du pack, désactivé tant qu'il manque un choix. */
    refresh: function (ctx) {
      var btn = qs("[data-product-add]", ctx.root);
      if (!btn) return;
      var tier = PackOffer.tier(ctx);
      var ready = PackOffer.complete(ctx);

      if (!PackOffer.firstVariantAvailable(ctx)) {
        btn.disabled = true;
        btn.textContent = btn.dataset.labelSoldOut;
        return;
      }
      btn.disabled = !ready;
      btn.textContent = ready
        ? btn.dataset.labelAvailable + " — " + formatMoney(tier.total)
        : (btn.dataset.labelPackIncomplete || btn.dataset.labelAvailable);
    },

    /* Persistance : un rafraîchissement de page ne doit pas perdre les choix de la cliente. */
    persist: function (ctx) {
      var data = { tier: PackOffer.tier(ctx).qty, items: [] };
      qsa("[data-pack-item]", ctx.root).forEach(function (item) {
        var colorSelect = qs("[data-pack-color]", item);
        var sizeSelect = qs("[data-pack-size]", item);
        data.items.push({
          index: item.dataset.packItemIndex,
          color: colorSelect ? colorSelect.value : "",
          size: sizeSelect ? sizeSelect.value : ""
        });
      });
      try { sessionStorage.setItem(ctx.storageKey, JSON.stringify(data)); } catch (e) {}
    },

    restore: function (ctx) {
      var raw = null;
      try { raw = sessionStorage.getItem(ctx.storageKey); } catch (e) {}
      if (!raw) return;
      var data;
      try { data = JSON.parse(raw); } catch (e) { return; }

      var radio = qsa("[data-pack-tier]", ctx.packEl).find(function (r) {
        return parseInt(r.dataset.packQty, 10) === data.tier;
      });
      if (radio) radio.checked = true;

      (data.items || []).forEach(function (saved) {
        var item = qs('[data-pack-item][data-pack-item-index="' + saved.index + '"]', ctx.root);
        if (!item) return;
        var colorSelect = qs("[data-pack-color]", item);
        var sizeSelect = qs("[data-pack-size]", item);
        // On ne restaure qu'une valeur qui existe toujours réellement dans le sélecteur.
        if (colorSelect && saved.color && qs('option[value="' + escapeAttr(saved.color) + '"]', colorSelect)) colorSelect.value = saved.color;
        if (sizeSelect && saved.size && qs('option[value="' + escapeAttr(saved.size) + '"]', sizeSelect)) sizeSelect.value = saved.size;
      });
    },

    clear: function (ctx) {
      try { sessionStorage.removeItem(ctx.storageKey); } catch (e) {}
    }
  };

  /* ---------- Product variant picker ------------------------------------ */
  function initProductForms() {
    // DEBUG TEMPORAIRE — à retirer une fois le bug sélecteur de variantes confirmé résolu en vrai navigateur.
    console.log("[SCULPTEA DEBUG] initProductForms() démarre, scripts data-product-json trouvés :", qsa("[data-product-json]").length);
    qsa("[data-product-json]").forEach(function (script) {
      var product;
      try {
        product = JSON.parse(script.textContent);
      } catch (e) {
        console.error("[SCULPTEA DEBUG] JSON.parse(product.json) a échoué — le picker ne sera PAS initialisé pour ce produit.", e);
        return;
      }
      var root = script.closest("[data-product-root]");
      if (!root) {
        console.error("[SCULPTEA DEBUG] Aucun [data-product-root] parent trouvé pour ce script — abandon.");
        return;
      }
      var variants = product.variants;
      console.log("[SCULPTEA DEBUG] Produit chargé :", product.title, "| variantes :", variants.length);
      console.log("[SCULPTEA DEBUG] variants[0] JSON brut complet (tous les champs réels) :", JSON.stringify(variants[0]));
      // Comparaison rendu initial serveur (Liquid, current_variant.available) vs product.json (JS) —
      // pour la même variante initiale, permet de voir si Liquid et le JSON du produit divergent.
      var addBtnInitial = qs("[data-product-add]", root);
      if (addBtnInitial) {
        console.log(
          "[SCULPTEA DEBUG] Rendu initial Liquid -> variant.id:", addBtnInitial.dataset.initialVariantId,
          "| current_variant.available (Liquid):", addBtnInitial.dataset.initialAvailable
        );
      }

      function getSelectedOptions() {
        var values = [];
        qsa("[data-option-index]", root).forEach(function (group) {
          var checked = group.querySelector("input:checked");
          values[parseInt(group.dataset.optionIndex, 10)] = checked ? checked.value : null;
        });
        return values;
      }
      function findVariant() {
        var selected = getSelectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }
      function updateAvailability() {
        var selected = getSelectedOptions();
        qsa("[data-option-index]", root).forEach(function (group) {
          var idx = parseInt(group.dataset.optionIndex, 10);
          qsa("input", group).forEach(function (input) {
            var test = selected.slice();
            test[idx] = input.value;
            var match = variants.find(function (v) {
              return v.options.every(function (opt, i) { return test[i] == null || opt === test[i]; });
            });
            input.disabled = !match;
          });
        });
      }
      function imageUrlAtWidth(src, width) {
        // Ajoute/remplace proprement le paramètre de largeur sur une URL CDN Shopify réelle,
        // sans dépendre du nom de fichier (robuste, méthode officielle par paramètre de requête).
        var sep = src.indexOf("?") === -1 ? "?" : "&";
        return src + sep + "width=" + width;
      }

      function setActiveThumb(mediaId) {
        qsa("[data-gallery-thumb]", root).forEach(function (t) {
          t.classList.toggle("is-active", mediaId != null && String(t.dataset.mediaId) === String(mediaId));
        });
      }

      function render() {
        var selected = getSelectedOptions();
        var variant = findVariant();
        console.log("[SCULPTEA DEBUG] render() — options sélectionnées :", selected, "| variante trouvée :", variant ? variant.id : null, variant);
        var priceEl = qs("[data-product-price]", root);
        var comparePriceEl = qs("[data-product-compare-price]", root);
        var addBtn = qs("[data-product-add]", root);
        var idInput = qs('input[name="id"]', root);
        var mainImage = qs("[data-product-main-image]", root);

        // Le libellé "Couleur : X" est mis à jour ici (bug confirmé : jamais fait auparavant côté JS).
        var colorGroupEl = qs('[data-option-name="Couleur"]', root);
        if (colorGroupEl) {
          var colorValueEl = qs("[data-selected-option-value]", colorGroupEl);
          var colorIdx = parseInt(colorGroupEl.dataset.optionIndex, 10);
          if (colorValueEl && selected[colorIdx]) colorValueEl.textContent = selected[colorIdx];
        }

        if (variant) {
          if (idInput) idInput.value = variant.id;
          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (comparePriceEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              comparePriceEl.textContent = formatMoney(variant.compare_at_price);
              comparePriceEl.hidden = false;
            } else {
              comparePriceEl.hidden = true;
            }
          }
          if (addBtn) {
            // DEBUG TEMPORAIRE — cause exacte du "Épuisé" : détail complet de la variante juste
            // avant la décision du texte du bouton, rien de simulé, valeurs réelles du product.json.
            console.log(
              "[SCULPTEA DEBUG] Décision bouton -> variant.id:", variant.id,
              "| variant.title:", variant.title,
              "| variant.available:", variant.available, "(type:", typeof variant.available, ")",
              "| inventory_management:", variant.inventory_management,
              "| inventory_policy:", variant.inventory_policy,
              "| inventory_quantity:", variant.inventory_quantity
            );
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? addBtn.dataset.labelAvailable : addBtn.dataset.labelSoldOut;
            console.log("[SCULPTEA DEBUG] État final bouton -> disabled:", addBtn.disabled, "| texte affiché:", addBtn.textContent);
          }
          if (variant.featured_image) {
            console.log("[SCULPTEA DEBUG] Mise à jour image principale ->", variant.featured_image.src, "| mainImage trouvé :", !!mainImage);
            if (mainImage) {
              mainImage.src = imageUrlAtWidth(variant.featured_image.src, 800);
              mainImage.dataset.mediaId = variant.featured_image.id;
              mainImage.alt = variant.featured_image.alt || mainImage.alt;
            }
            setActiveThumb(variant.featured_image.id);
          } else {
            console.log("[SCULPTEA DEBUG] Cette variante n'a pas de featured_image lié — image principale inchangée.");
          }
          // Met à jour l'URL avec ?variant=ID sans recharger la page, pour permettre un lien direct.
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", url);
          }
        } else if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelUnavailable || addBtn.dataset.labelSoldOut;
        }
        updateAvailability();
        // Offre Duo/Trio : c'est le pack qui a le dernier mot sur le libellé et l'état du bouton.
        if (root.__sculpteaPack) PackOffer.refresh(root.__sculpteaPack);
      }

      var optionInputs = qsa("[data-option-index] input", root);
      console.log("[SCULPTEA DEBUG] Radios/inputs d'option trouvés pour écouteur 'change' :", optionInputs.length);
      // DEBUG TEMPORAIRE — détail de chaque input réel (nom, valeur, état checked, index du groupe parent).
      optionInputs.forEach(function (input) {
        var group = input.closest("[data-option-index]");
        console.log(
          "[SCULPTEA DEBUG] input ->",
          (group && group.dataset.optionName) || "?",
          "|", input.value,
          "| checked=" + input.checked,
          "| name=" + input.name,
          "| optionIndex=" + (group ? group.dataset.optionIndex : "?")
        );
      });
      // DEBUG TEMPORAIRE — pour chaque groupe, ce que querySelector("input:checked") trouve réellement.
      qsa("[data-option-index]", root).forEach(function (group) {
        var checked = group.querySelector("input:checked");
        console.log(
          "[SCULPTEA DEBUG] groupe ->", group.dataset.optionName, "| optionIndex=" + group.dataset.optionIndex,
          "| tag=" + group.tagName, "| input:checked trouvé =", checked ? checked.value : null
        );
      });
      optionInputs.forEach(function (input) {
        input.addEventListener("change", render);
      });

      // Cliquer une vignette doit aussi resynchroniser les sélecteurs (couleur) sur la vraie
      // variante associée à ce média — pas seulement changer l'image affichée.
      qsa("[data-gallery-thumb]", root).forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var mediaId = thumb.dataset.mediaId;
          var matchingVariant = variants.find(function (v) {
            return v.featured_image && String(v.featured_image.id) === String(mediaId);
          });
          if (matchingVariant) {
            var colorGroup = qs('[data-option-name="Couleur"]', root);
            if (colorGroup) {
              var colorIndex = parseInt(colorGroup.dataset.optionIndex, 10);
              var colorValue = matchingVariant.options[colorIndex];
              var radio = qsa("input", colorGroup).find(function (r) { return r.value === colorValue; });
              if (radio && !radio.checked) {
                radio.checked = true;
                render();
                return;
              }
            }
          }
          // Produit sans option couleur (ou média non lié à une variante) : simple aperçu visuel.
          var main = qs("[data-product-main-image]", root);
          if (main) { main.src = thumb.dataset.full || thumb.src; main.dataset.mediaId = mediaId; }
          setActiveThumb(mediaId);
        });
      });

      var qtyMinus = qs("[data-qty-decrease]", root);
      var qtyPlus = qs("[data-qty-increase]", root);
      var qtyInput = qs("[data-qty-input]", root);
      if (qtyMinus && qtyInput) qtyMinus.addEventListener("click", function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || "1", 10) - 1);
      });
      if (qtyPlus && qtyInput) qtyPlus.addEventListener("click", function () {
        qtyInput.value = parseInt(qtyInput.value || "1", 10) + 1;
      });

      render();
    });

  }

  /* ---------- Size guide modal + quiz ------------------------------------ */
  var PANT_TO_LEGGING_SIZE = [
    { max: 34, size: "XS" },
    { max: 36, size: "S" },
    { max: 38, size: "M" },
    { max: 42, size: "L" },
    { max: 46, size: "XL" },
    { max: 50, size: "2XL" },
    { max: 54, size: "3XL" },
    { max: 58, size: "4XL" },
    { max: 999, size: "5XL" }
  ];
  // Tableau de référence Maison Sculptea (guide des tailles fourni par la marque) : taille de
  // bonnet (déduite de l'écart tour de poitrine - tour de dessous de poitrine) x tour de dos FR
  // (déduit du tour de dessous de poitrine), converti en taille Maison Sculptea S-3XL.
  var BRA_BAND_BOUNDS = [73, 78, 83, 88, 93, 98, 103]; // bornes hautes des tours de dessous de poitrine pour bandes 32,34,36,38,40,42,44,46(dernière)
  var BRA_CUP_BOUNDS = [12, 14, 16, 18, 20, 22]; // bornes hautes de l'écart (cm) pour bonnets A,B,C,D,DD,DDD(dernier)
  var BRA_SIZE_MATRIX = [
    ["S", "S", "M", "L", "XL", "2XL", "3XL", "3XL"], // A
    ["S", "M", "M", "L", "XL", "2XL", "3XL", "3XL"], // B
    ["S", "M", "L", "L", "XL", "2XL", "3XL", "3XL"], // C
    ["S", "M", "L", "XL", "2XL", "2XL", "3XL", "3XL"], // D
    ["M", "L", "XL", "XL", "2XL", "3XL", "3XL", "3XL"], // DD
    ["M", "L", "XL", "2XL", "2XL", "3XL", "3XL", "3XL"] // DDD
  ];

  function indexFromBounds(bounds, value) {
    for (var i = 0; i < bounds.length; i++) {
      if (value <= bounds[i]) return i;
    }
    return bounds.length;
  }

  function braSizeFromMeasurements(under, bust) {
    var bandIndex = indexFromBounds(BRA_BAND_BOUNDS, under);
    var cupIndex = indexFromBounds(BRA_CUP_BOUNDS, Math.max(0, bust - under));
    return BRA_SIZE_MATRIX[cupIndex][bandIndex];
  }

  function sizeFromTable(table, value) {
    for (var i = 0; i < table.length; i++) {
      if (value <= table[i].max) return table[i].size;
    }
    return table[table.length - 1].size;
  }

  function initSizeGuide() {
    var overlay = qs("[data-size-guide-overlay]");
    var modal = qs("[data-size-guide-modal]");
    if (!modal) return;

    function open(type) {
      modal.dataset.activeType = type || "leggings";
      qsa("[data-size-guide-type]", modal).forEach(function (el) {
        el.hidden = el.dataset.sizeGuideType !== modal.dataset.activeType;
      });
      modal.classList.add("is-open");
      if (overlay) overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function close() {
      modal.classList.remove("is-open");
      if (overlay) overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }
    qsa("[data-size-guide-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        open(btn.dataset.sizeGuideTrigger);
      });
    });
    qsa("[data-size-guide-close]", modal).forEach(function (btn) { btn.addEventListener("click", close); });
    if (overlay) overlay.addEventListener("click", close);

    // Tabs
    qsa("[data-size-guide-tab]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        var group = tab.closest("[data-size-guide-type]");
        qsa("[data-size-guide-tab]", group).forEach(function (t) { t.classList.remove("is-active"); });
        tab.classList.add("is-active");
        qsa("[data-size-guide-panel]", group).forEach(function (p) {
          p.classList.toggle("is-active", p.dataset.sizeGuidePanel === tab.dataset.sizeGuideTab);
        });
      });
    });

    // Leggings quiz
    qsa('[data-quiz="leggings"]').forEach(function (form) {
      var pantSelect = qs('[name="pant_size"]', form);
      var noPantToggle = qs('[data-no-pant-size]', form);
      var measurementsBlock = qs('[data-pant-measurements]', form);
      if (noPantToggle) {
        noPantToggle.addEventListener("change", function () {
          if (measurementsBlock) measurementsBlock.hidden = !noPantToggle.checked;
          if (pantSelect) pantSelect.disabled = noPantToggle.checked;
        });
      }
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var result = qs("[data-quiz-result]", form);
        var size;
        if (noPantToggle && noPantToggle.checked) {
          var waist = parseInt(qs('[name="waist"]', form).value, 10) || 0;
          var hips = parseInt(qs('[name="hips"]', form).value, 10) || 0;
          var estimatedPant = Math.round(((waist + hips) / 2 - 60) / 2) * 2 + 34;
          size = sizeFromTable(PANT_TO_LEGGING_SIZE, estimatedPant);
        } else {
          var pant = parseInt(pantSelect.value, 10) || 38;
          size = sizeFromTable(PANT_TO_LEGGING_SIZE, pant);
        }
        if (result) {
          qs("[data-quiz-size]", result).textContent = size;
          result.classList.add("is-visible");
        }
      });
    });

    // Bra quiz
    qsa('[data-quiz="bra"]').forEach(function (form) {
      var usualSelect = qs('[name="usual_size"]', form);
      var noUsualToggle = qs('[data-no-usual-size]', form);
      var measurementsBlock = qs('[data-bra-measurements]', form);
      if (noUsualToggle) {
        noUsualToggle.addEventListener("change", function () {
          if (measurementsBlock) measurementsBlock.hidden = !noUsualToggle.checked;
          if (usualSelect) usualSelect.disabled = noUsualToggle.checked;
        });
      }
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var result = qs("[data-quiz-result]", form);
        var size;
        if (noUsualToggle && noUsualToggle.checked) {
          var under = parseInt(qs('[name="bust_under"]', form).value, 10) || 80;
          var bust = parseInt(qs('[name="bust"]', form).value, 10) || (under + 14);
          size = braSizeFromMeasurements(under, bust);
        } else {
          size = usualSelect.value;
        }
        if (result) {
          qs("[data-quiz-size]", result).textContent = size;
          result.classList.add("is-visible");
        }
      });
    });
  }

  /* ---------- Before / after slider -------------------------------------- */
  function initBeforeAfter() {
    qsa("[data-before-after]").forEach(function (widget) {
      var range = qs('input[type="range"]', widget);
      var beforeLayer = qs(".before-after__before", widget);
      var handle = qs(".before-after__handle", widget);
      if (!range || !beforeLayer) return;
      function update() {
        var val = range.value;
        beforeLayer.style.width = val + "%";
        beforeLayer.querySelector("img").style.width = (10000 / val) + "%";
        if (handle) handle.style.left = val + "%";
      }
      range.addEventListener("input", update);
      update();
    });
  }

  /* ---------- Apparition au scroll (image, texte, bénéfices en cascade) — une seule fois */
  function initSculptSweep() {
    var els = qsa("[data-scroll-reveal]");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in-view"); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in-view");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---------- Coloris cliquables sur les cartes produit / vitrine -------- */
  // Fonctionne pour les cartes de grille (data-swatch-group = le <a> lui-même) et la vitrine
  // "un seul produit" (data-swatch-group = un conteneur, avec un <a data-product-card-link> à
  // l'intérieur). Chaque bouton coloris porte le vrai variant.id et la vraie image liée à cette
  // variante — rien n'est simulé. Un clic met à jour l'image ET l'URL (?variant=ID) de la carte.
  function initProductCardSwatches() {
    qsa("[data-swatch-group]").forEach(function (group) {
      var img = qs("[data-product-card-image]", group);
      var link = group.tagName === "A" ? group : qs("a[data-product-card-link]", group);
      var baseUrl = group.dataset.baseUrl || (link ? link.getAttribute("href") : null);
      if (!baseUrl) return;
      qsa("[data-color-swatch]", group).forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var imageUrl = btn.dataset.image;
          var variantId = btn.dataset.variantId;
          if (img && imageUrl) img.src = imageUrl;
          qsa("[data-color-swatch]", group).forEach(function (s) { s.classList.remove("is-active"); });
          btn.classList.add("is-active");
          if (link && variantId) {
            try {
              var url = new URL(baseUrl, window.location.origin);
              url.searchParams.set("variant", variantId);
              link.setAttribute("href", url.pathname + url.search);
            } catch (err) {}
          }
        });
      });
    });
  }

  /* ---------- Toast d'offre (à chaque nouvelle arrivée sur le site) ------ */
  // sessionStorage (pas localStorage) : la fermeture ne reste mémorisée que pour la navigation
  // en cours (onglet/session actuels) — dès qu'on revient plus tard (nouvel onglet frais, nouvelle
  // visite après fermeture du navigateur), sessionStorage est vide et le toast réapparaît.
  var OFFER_TOAST_KEY = "sculptea_offer_toast_dismissed";
  function initOfferToast() {
    var toast = qs("[data-offer-toast]");
    if (!toast) return;
    var dismissed = false;
    try { dismissed = sessionStorage.getItem(OFFER_TOAST_KEY) === "1"; } catch (e) { dismissed = false; }
    if (dismissed) return;

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      toast.hidden = false;
      // Force un reflow avant d'ajouter la classe, pour que la transition CSS se joue réellement.
      void toast.offsetWidth;
      requestAnimationFrame(function () { toast.classList.add("is-visible"); });
    }
    function dismiss() {
      toast.classList.remove("is-visible");
      try { sessionStorage.setItem(OFFER_TOAST_KEY, "1"); } catch (e) {}
      setTimeout(function () { toast.hidden = true; }, 450);
    }

    var closeBtn = qs("[data-offer-toast-close]", toast);
    if (closeBtn) closeBtn.addEventListener("click", dismiss);

    // Déclencheur : après un court délai, OU dès qu'un petit scroll a lieu — le premier des deux.
    var timer = setTimeout(show, 4500);
    var onScroll = function () {
      if (window.scrollY > 250) {
        show();
        window.removeEventListener("scroll", onScroll);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---------- Init ---------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    Cart.init();
    Cart.updateCount();
    initProductForms();
    PackOffer.init();
    initSizeGuide();
    initBeforeAfter();
    initSculptSweep();
    initOfferToast();
    initProductCardSwatches();
  });
})();
